import React from 'react'
import '../../i18n';
import { useTranslation } from "react-i18next";

export default function Filter(props) {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className='filter-text'>{ t("championship.filter.searchBy") }</div>
      <div className='filter-field'>
        <input value={props.term} onChange={props.filterResults} type='text' />
      </div>
      <div className='filter-tip'>
        { t('championship.filter.searchTip')}
        </div>
    </React.Fragment>
  )
};
